module.exports = __webpack_public_path__ + "img/img.ac62be31.gif";